import { Image } from "@shopify/hydrogen-react";
import {
  Box,
  CopyToClipboard,
  FlexRow,
  H1,
  H3,
  Link,
  SiteContainer,
  Stack,
  Text,
} from "atoms";
import { StepProps } from "features/shop/types";
import { useParams } from "react-router-dom";
import { paths } from "utils/paths";

function StepDone({ state }: StepProps) {
  const { artistId = "" } = useParams<{ artistId: string }>();
  return (
    <SiteContainer>
      <Stack gap="sm">
        <H1 size="xl" textTransform="none" textAlign="center">
          You&apos;re All Done!
        </H1>

        <Box>
          <Stack gap="md">
            <H3 size="lg" bold textAlign="center" textTransform="none">
              {state.product.title} <br />
              <small>is ready to sell!</small>
            </H3>
            <Box border small style={{ maxWidth: 280, marginInline: "auto" }}>
              <FlexRow justifyContent="center" flexDirection="column">
                <Image data={state.product} width="150" height="150" />
                <Stack gap="xs">
                  <Text
                    font="display"
                    textTransform="none"
                    textAlign="center"
                    bold
                  >
                    <Link
                      to={paths.artistShopProduct(
                        artistId,
                        state.product.handle,
                      )}
                    >
                      View Product
                    </Link>
                  </Text>
                  <CopyToClipboard
                    value={paths.artistShopProduct(
                      artistId,
                      state.product.handle,
                    )}
                    buttonText="Copy product link"
                  />
                </Stack>
              </FlexRow>
            </Box>

            <FlexRow justifyContent="center">
              <Link
                variant="primary"
                to={paths.artistShopProductCreate(artistId)}
              >
                Create Another Product
              </Link>
              <Link variant="secondary" to={paths.artistShopEdit(artistId)}>
                Manage Products
              </Link>
            </FlexRow>
          </Stack>
        </Box>
      </Stack>
    </SiteContainer>
  );
}
StepDone.displayName = "Done";

export { StepDone };
